import { AtSign } from "lucide-react"
import { SectionCard } from "@/components/ui/SectionCard"
import companyFormStyles from "@/features/company/styles/companyAdd.module.css"
import type { TransferPropertyInfoSectionProps } from "./propertyInfoSectionTypes"

/**
 * Angular `transfer-process.component.html` — `updatedomain` / `newdomain` controls
 * (Angular keeps them in a `d-none` row; React exposes them for BR-039 / CMP-TRANSFER-BR-039).
 */
export function TransferEmailDomainSection({ ctx }: TransferPropertyInfoSectionProps) {
  const { fragment, watch, setValueValidated, domains, newdomains } = ctx
  if (!fragment || ["transfer_resident", "transfer_property", "transfer_company", "split_property", "merge_property"].includes(fragment)) return null

  const updateDomain = watch("updatedomain")
  const newdomain = watch("newdomain")

  return (
    <SectionCard
      icon={AtSign}
      title="Email Domain"
      testId="transfer-process-email-domain-section"
      titleTestId="transfer-process-email-domain-section-title"
    >
      {(domains || newdomains) && (
        <p
          data-testid="transfer-process-email-domain-hint"
          className="mb-4 text-sm text-slate-600"
        >
          Staff email domains: {domains || "—"}
          {newdomains ? ` → ${newdomains}` : ""}
        </p>
      )}
      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        <div className={companyFormStyles.formGroup}>
          <span
            data-testid="transfer-process-email-domain-change-label"
            className={companyFormStyles.formLabel}
          >
            Change Email Domain?
          </span>
          <div className="mt-2 flex flex-wrap gap-6">
            <label className="inline-flex cursor-pointer items-center gap-2 text-sm text-[#253c5c]">
              <input
                type="radio"
                name="transfer-updatedomain"
                value="1"
                checked={updateDomain === "1"}
                data-testid="transfer-process-email-domain-yes-radio"
                className="h-4 w-4 cursor-pointer"
                onChange={() => setValueValidated("updatedomain", "1")}
              />
              Yes
            </label>
            <label className="inline-flex cursor-pointer items-center gap-2 text-sm text-[#253c5c]">
              <input
                type="radio"
                name="transfer-updatedomain"
                value="0"
                checked={updateDomain === "0"}
                data-testid="transfer-process-email-domain-no-radio"
                className="h-4 w-4 cursor-pointer"
                onChange={() => setValueValidated("updatedomain", "0")}
              />
              No
            </label>
          </div>
        </div>
        {updateDomain === "1" && (
          <div className={companyFormStyles.formGroup}>
            <label
              data-testid="transfer-process-email-domain-name-label"
              htmlFor="transfer-process-email-domain-name-input"
              className={companyFormStyles.formLabel}
            >
              Domain Name
            </label>
            <input
              id="transfer-process-email-domain-name-input"
              type="text"
              data-testid="transfer-process-email-domain-name-input"
              className={companyFormStyles.customFormControl}
              placeholder={newdomains || "example.com"}
              value={newdomain ?? ""}
              onChange={(e) => setValueValidated("newdomain", e.target.value)}
            />
          </div>
        )}
      </div>
    </SectionCard>
  )
}
